<template>

    <div class="order-copy pop_white-s pop_bege popup_wrap" style="display:block">
        <div class="popup_in">
            <div class="popup">

                <div class="popup_close stay_close close-animate">
                    <a href="javascript:void(0);" @click.prevent="closePop">
                        <close />
                    </a>
                </div>
                <div class="corner-top"></div>
                <div class="exists_icon">
                    <LOGO />
                </div>
                <div class="pop_frame">
                    <h2 class="title25" style="margin-top:20px;">היי, שמת לב שיש לך הזמנה קבועה פעילה?</h2>
                    <div class="text"></div>
                    <div class="bt_green ease">
                        <a href="#" @click.prevent="goToChekoutPage">כן, אני רוצה להמשיך</a>
                    </div>
                    <div class="bt_green ease">
                        <a href="#" @click.prevent="goToPermOrderPage">לא, קחו אותי לרשימת המוצרים</a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import close from "../../assets/img/close.svg";
    import LOGO from "../../assets/img/carmella.svg";
    import { mapActions } from "vuex";
    export default {
        name: "hasPerOrder",
        data() {
            return {};
        },
        methods: {

            goToPermOrderPage() {
                this.closePop();
                this.$router.push({name: 'permenent'});

            },
            goToChekoutPage(){
                this.closePop();
                this.$store.commit('setPermOrderEdit',0);
                this.$router.push({ name: "checkout" });
            },
            closePop() {
                this.$emit('close');
            }
        },
        components: {
            LOGO,
            close
        }
    }
</script>

<style scoped>
    .bt_green a {
        width: 320px;
    }
</style>